/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.PropertyType_
///   This is an auto-generated enumeration of the SW_RealEstate.Core.PropertyType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum PropertyType_ {
   /// <summary>
   ///   Sale (Sale)
   /// </summary>
   Sale = 1,
   /// <summary>
   ///   Rental (Rent)
   /// </summary>
   Rental = 2,
   /// <summary>
   ///   Referral (Ref)
   /// </summary>
   Referral = 3
}

export const PropertyTypes: PropertyType[] = [
   {
      code: PropertyType_.Sale,
      literal: 'Sale',
      description: 'Sale',
      shortDescription: 'Sale',
      listPriority: 0,

      typeName: "PropertyType"
   },
   {
      code: PropertyType_.Rental,
      literal: 'Rental',
      description: 'Rental',
      shortDescription: 'Rent',
      listPriority: 0,

      typeName: "PropertyType"
   },
   {
      code: PropertyType_.Referral,
      literal: 'Referral',
      description: 'Referral',
      shortDescription: 'Ref',
      listPriority: 0,

      typeName: "PropertyType"
   }
]

export class PropertyType implements IDomainModel {
   code: PropertyType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: PropertyType_): PropertyType {
      return PropertyTypes.find(d => d.code === code)
   }
}
